export const ROLE_COURT_TYPE = {
  sector_head_poly: "Πολυμελές",
  sector_head_mono: "Μονομελές",
  composition_president: "Πολυμελές",
};

export const ROLE_BADGE = {
  admin: "Admin", katastima: "Κατάστημα", dispatch: "Διακίνηση", judge: "Δικαστής",
  sector_head_poly: "Υπ. Τομέα Πολ.", sector_head_mono: "Υπ. Τομέα Μον.", composition_president: "Πρόεδρος Σύνθεσης",
};
